import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import './Certifications.css';

const Certifications = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const certifications = [
    {
      title: 'Google IT Automation with Python',
      provider: 'Google',
      year: '2023',
      type: 'Professional Certificate'
    },
    {
      title: 'Google Cybersecurity',
      provider: 'Google',
      year: '2023',
      type: 'Professional Certificate'
    },
    {
      title: 'IBM Cybersecurity Analyst',
      provider: 'IBM',
      year: '2023',
      type: 'Professional Certificate'
    },
    {
      title: 'Essentials of Ethical Hacking',
      provider: 'EC-Council',
      year: '2023',
      type: 'Certification'
    },
    {
      title: 'ISO 27001',
      provider: 'SkillFront',
      year: '2023',
      type: 'Certification'
    }
  ];

  return (
    <section id="certifications" className="section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 24 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <div className="section-head">
            <span className="section-path">certifications</span>
            <h2>Credentials</h2>
          </div>

          <ul className="cert-list">
            {certifications.map((cert, index) => (
              <motion.li
                key={index}
                className="cert-row"
                initial={{ opacity: 0, y: 16 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: 0.05 * index }}
              >
                <span className="cert-year">{cert.year}</span>
                <div className="cert-body">
                  <h3>{cert.title}</h3>
                  <span className="cert-meta">{cert.provider} · {cert.type}</span>
                </div>
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default Certifications;
